import { render, staticRenderFns } from "./step1.vue?vue&type=template&id=8a40f700&scoped=true"
import script from "./step1.vue?vue&type=script&lang=js"
export * from "./step1.vue?vue&type=script&lang=js"
import style0 from "./step1.vue?vue&type=style&index=0&id=8a40f700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a40f700",
  null
  
)

export default component.exports